import { render, staticRenderFns } from "./modal-callback-main.vue?vue&type=template&id=6ab2a436&"
import script from "./modal-callback-main.vue?vue&type=script&lang=js&"
export * from "./modal-callback-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckboxGroup: require('/var/www/components/checkbox/checkbox-group.vue').default,InputsInput: require('/var/www/components/inputs/input.vue').default})
